<template>
	<div>
		<div class="candDocs-main-container">
			<div class="canDocs-uld w-100">
				<div class="canDocs-pg-head p-2 px-3">Upload Documents</div>
			</div>
			<div class="d-flex justify-content-between max-1825">
				<div class="candDocs-left-container mt-2">
					<div class="container-head-uld p-3">
						<span>Please upload the required documents</span>
					</div>

					<div
						v-if="shimmerLoader"
						class="d-flex flex-wrap position-relative w-100 mt-4"
					>
						<div
							v-for="i in shimmerLoop"
							:key="i"
							class="candDocs-particular-doc m-4"
						>
							<div class="d-flex justify-content-center" style="height: 60%">
								<!-- <b-skeleton class="skel-w60 h-100"></b-skeleton> -->
								<b-skeleton
									type="button"
									class="shimmer-box"
									style="width: 50%; height: 50%"
								></b-skeleton>
							</div>
							<div class="mt-5">
								<b-skeleton class="skel-h25"></b-skeleton>
							</div>
						</div>
					</div>

					<div class="candDocs-containers px-4 pb-2">
						<div
							class="mt-2 candDocs-sub-containers pointer"
							:class="docs.openModal ? 'padding-open' : 'padding-close'"
							v-for="(docs, index) in documents"
							:key="index + 'docs'"
							@click.stop="toggleModal(index, docs)"
						>
							<div class="d-flex align-items-center justify-content-between">
								<div class="d-flex align-items-center mb-2">
									<div class="doc-img-bckg mr-2">
										<img
											class="ml-1"
											height="16px"
											width="16px"
											:src="docs.image"
										/>
									</div>
									<div class="card-head-uld mb-1">
										{{ docs.categoryTitle }}
									</div>
								</div>
								<div v-if="!docs.openModal">
									<img
										class="pointer mb-3"
										src="../../assets/candidate-documents/uld-dwn-arr.svg"
										alt=""
									/>
								</div>
								<div v-else>
									<img
										class="pointer mb-3"
										src="../../assets/candidate-documents/docCategoryDownIcon.svg"
										alt=""
									/>
								</div>
							</div>
							<div class="d-flex flex-wrap" v-if="docs.openModal">
								<div
									class="pointer ucdSelDocFile position-relative mt-3 w-94px ml-4"
									v-for="(defineDocuments, index1) in docs.documents"
									:key="index1 + 'defineDocuments'"
									:class="{
										'upload-danger': error,
										'text-danger':
											defineDocuments.maxSize || defineDocuments.isNotPDF,
									}"
									@click.stop="
										defineDocuments.isUploaded
											? previewDoc(defineDocuments, index, index1)
											: ''
									"
								>
									<div
										:class="{
											'candDocs-particular-doc-unselected':
												defineDocuments.isUploaded,
											'candDocs-particular-others-doc position-relative docstooltips':
												!defineDocuments.isUploaded,
											'selected-border': defineDocuments.defineDocPreview,
											'candDocs-particular-others-doc-error':
												defineDocuments.maxSize || defineDocuments.isNotPDF,
										}"
									>
										<b-overlay
											:show="defineDocuments.loaderStatus"
											rounded="sm"
											class="custom-overlay"
										>
											<div v-if="!defineDocuments.isUploaded">
												<b-form-file
													class="mb-2 pointer"
													accept="application/pdf"
													@change="
														handleFileChange(
															$event,
															index,

															index1,
															defineDocuments
														)
													"
												>
												</b-form-file>
											</div>
											<div
												class="cloud-box-uld d-flex justify-content-center align-items-center"
											>
												<img
													v-if="defineDocuments.isUploaded"
													src="../../assets/candidate-documents/uld-img-after.svg"
													alt=""
												/>
												<div
													v-else-if="
														defineDocuments.maxSize || defineDocuments.isNotPDF
													"
													class="mb-1"
												>
													<img
														src="../../assets/candidate-documents/doc-uploaded-err.svg"
													/>
													<div class="cloud-card-error">Failed</div>
												</div>
												<img
													v-else
													src="../../assets/candidate-documents/candDocs-download-icon.svg"
													alt=""
												/>

												<!-- error img and text -->
											</div>
										</b-overlay>
										<div class="bluett">
											<div class="position-relative">
												<div class="udarw">
													<img
														src="../../assets/icons/candidatedashboard/udarw.svg"
														alt=""
													/>
												</div>
											</div>
											<div class="">
												<div
													class="bluett-text-danger"
													v-if="defineDocuments.maxSize"
												>
													File size limit Exceeded<br />(.pdf) max 10 mb
												</div>
												<div
													class="bluett-text-danger"
													v-else-if="defineDocuments.isNotPDF"
												>
													Invalid File Format. <br />
													Allowed file .pdf
												</div>
												<div class="bluett-text-primary" v-else>
													Upload your document<br />(.pdf) max 10 mb
												</div>
											</div>
										</div>
									</div>
									<div
										class="mt-2 candDocs-particular-doc-font text-truncate"
										:class="{
											'blue-txt-selctd': defineDocuments.defineDocPreview,
										}"
									>
										{{ defineDocuments.documentName }}
									</div>
								</div>
								<div
									class="pointer position-relative w-94px ml-4"
									v-for="(otherDocuments, index2) in docs.otherDocuments"
									:key="index2 + 'otherDocuments'"
									@click.stop="previewOtherDoc(otherDocuments, index, index2)"
								>
									<div
										class="candDocs-particular-doc-unselected mt-3"
										:class="{
											'selected-border': otherDocuments.otherDocPreview,
											'unselected-border': !otherDocuments.otherDocPreview,
										}"
									>
										<div
											class="cloud-box-uld align-items-center d-flex justify-content-center"
										>
											<img
												src="../../assets/candidate-documents/uld-img-after.svg"
												alt=""
											/>
										</div>
									</div>
									<div
										class="mt-2 candDocs-particular-doc-font text-truncate"
										:class="{
											'blue-txt-selctd': otherDocuments.otherDocPreview,
										}"
									>
										{{ otherDocuments.documentName }}
									</div>
								</div>

								<div class="ml-4">
									<div
										class="candDocs-particular-others-doc position-relative pointer mt-3"
										@click.stop="openOtherDocumentModal(docs, index)"
									>
										<div
											class="cloud-box-uld align-items-center d-flex justify-content-center"
										>
											<div class="cloud-uld-img">
												<img
													src="../../assets/candidate-documents/other-docs-web.svg"
													alt=""
												/>
											</div>
										</div>
									</div>
									<div class="mt-2 candDocs-particular-doc-font text-truncate">
										Other documents
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="candDocs-right-container mt-2 ml-2">
					<template v-if="shimmerLoader">
						<div class="mt-2" style="width: 50%; height: 5%; padding: 8px">
							<b-skeleton class="head-text"> </b-skeleton>
						</div>
						<div
							class="candDocs-right-container"
							style="width: 100%; padding: 8px"
						>
							<b-skeleton class="h-100"></b-skeleton>
						</div>
					</template>
					<template v-if="noModalsOpen">
						<div class="d-flex justify-content-center align-items-center h-100">
							<div>
								<div class="ml-3">
									<img
										src="../../assets/candidate-documents/previewDocSvg.svg"
									/>
								</div>
								<div class="no-docs-im-txt mt-4">
									Select document to preview
								</div>
							</div>
						</div>
					</template>
					<template v-if="previewDocs && !shimmerLoader && !noDocsToPreview">
						<div class="h-100">
							<div
								class="d-flex head-box-uld-left justify-content-between w-100 px-3 py-3"
							>
								<div class="right-cont-head w-75 text-truncate">
									{{ pdfLink.name }}
								</div>
								<div>
									<div
										class="position-relative pointer"
										v-closable="{
											exclude: ['ref1', 'ref2'],
											handler: 'closeToggleInfo',
										}"
									>
										<div
											ref="ref1"
											@click="toggleInfo()"
											class="position-relative d-flex align-items-center justify-content-center"
											:class="info ? 'js-info-icon-clicked' : 'js-info-hover'"
										>
											<img
												src="../../assets/job-search-icons/new-info-icon.svg"
												alt=""
											/>
										</div>
										<div class="candlst-dropdown mt-1" v-if="info" ref="ref2">
											<div
												:class="[
													'd-flex align-items-center',
													selectedOption === 'download'
														? 'candlst-selected'
														: 'candlst-unsel',
												]"
												@click="
													selectOption('download');
													downloadDoc(pdfLink.link);
												"
											>
												<img
													src="../../assets/candidate-documents/dwnld-uld.svg"
													alt=""
												/>
												<span class="ml-3"> Download </span>
											</div>
											<div
												:class="[
													'd-flex align-items-center',
													selectedOption === 'replace'
														? 'candlst-selected'
														: 'candlst-unsel',
												]"
												@click="
													selectOption('replace');
													replaceDoc();
												"
											>
												<img
													src="../../assets/candidate-documents/doc-replace-icon.svg"
													alt=""
												/>
												<span class="ml-3"> Replace </span>
											</div>
											<div
												:class="[
													'd-flex align-items-center pointer',
													selectedOption === 'delete'
														? 'candlst-selected'
														: 'candlst-unsel',
												]"
												@click="
													selectOption('delete');
													deleteDoc(documentID);
												"
											>
												<img
													src="../../assets/candidate-documents/doc-trash.svg"
													alt=""
												/>
												<span class="ml-3"> Delete </span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- {{  numPages > 1 }} -->
							<div
								id="viewDocument"
								class="mt-3 p-2 m-2"
								style="box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16)"
								:class="
									numPages > 1
										? 'pagination-docs-resumePreview-height'
										: 'docs-resumePreview-height'
								"
							>
								<pdf
									ref="pdf"
									class="h-95 w-100"
									:src="pdfLink.link"
									:page="currentPage"
									@num-pages="numPages = $event"
									@link-clicked="currentPage = $event"
									@page-loaded="currentPage = $event"
								></pdf>
							</div>
							<div class="mt-4 uploadDocs-pagination" v-if="numPages > 1">
								<b-pagination
									align="center"
									first-number
									last-number
									v-model="currentPage"
									:total-rows="numPages"
									:per-page="perPage"
								>
									<template #prev-text>
										<span>
											<img
												class="uploadDocs-pagination-left-arrow"
												src="../../assets/candidate-documents/pagination-docs-left.svg"
												alt=""
											/>
										</span>
									</template>
									<template #next-text>
										<span>
											<img
												class="uploadDocs-pagination-right-arrow"
												src="../../assets/candidate-documents/pagination-docs-right.svg"
												alt=""
											/>
										</span>
									</template>
								</b-pagination>
							</div>
						</div>
					</template>

					<template v-if="noDocsToPreview && !shimmerLoader">
						<div class="d-flex justify-content-center align-items-center h-100">
							<div>
								<div class="ml-3">
									<img src="../../assets/candidate-documents/no-docs.svg" />
								</div>
								<div class="no-docs-im-txt mt-4">No documents uploaded</div>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>

		<DocumentsDelete :documentID="documentID" @updateDoc="updateDoc" />
		<DocumentsUpload
			:otherModal="otherModal"
			:defineDocName="defineDocName"
			:categoryID="categoryID"
			:defineDocReferenceID="defineDocReferenceID"
			:documentID="documentID"
			@updateDoc="updateDoc"
			@documentUploaded="handleDocumentUploaded"
		/>
	</div>
</template>

<script>
import pdf from "vue-pdf";
import toast from "../../components/mixin/toast";
import candidateDocsListMixin from "../../views/CandidateDocuments/CandidateDocsListMixin.js";
import DocumentsDelete from "./DocumentsDeleteModal.vue";
import DocumentsUpload from "./DocumentsUploadModal.vue";

export default {
	mixins: [toast, candidateDocsListMixin],
	components: {
		pdf,
		DocumentsDelete,
		DocumentsUpload,
	},
	data() {
		return {
			deletedIndex: null,
			someAction: false,
			selectedCategoryIndex: null,
			noModalsOpen: true,
			noDocsToPreview: false,
			shimmerLoader: false,
			docIndex: null,
			error: "",
			selectedFile: null,
			selectedFileName: "",
			selectedOption: "",
			categoryID: "",
			otherModal: false,
			documentID: "",
			previewDocs: false,
			defineDocName: "",
			defineDocReferenceID: "",
			info: false,
			loading: false,
			shimmerLoop: 18,
			documents: [],
			replaceName: "",
			numPages: 0,
			currentPage: 1,
			perPage: 1,
			pdfLink: {
				link: "",
				name: "",
			},
		};
	},

	created() {
		this.shimmerLoader = true;
		this.getAllDocs();
	},
	watch: {
		currentPage() {
			this.scrollToTop();
		},
	},

	methods: {
		async handleDocumentUploaded({ documentName }) {
			this.someAction = true;
			this.selectedCategoryIndex = this.docIndex;
			await this.getAllDocs();
			let found = false;

			for (let i in this.documents) {
				for (let j in this.documents[i].otherDocuments) {
					if (
						this.documents[i].otherDocuments[j].documentName === documentName
					) {
						this.selectedCategoryIndex = this.docIndex;
						this.deletedIndex = this.docIndex;

						this.previewOtherDoc(this.documents[i].otherDocuments[j], i, j);
						found = true;
						break;
					}
				}

				if (found) break;
			}
		},
		scrollToTop() {
			const element = document.getElementById("viewDocument");
			if (element) {
				element.scrollTo({
					top: 0,
					behavior: "smooth",
				});
			}
		},
		updateDoc() {
			this.someAction = true;
			this.selectedCategoryIndex = this.docIndex;
			this.deletedIndex = this.docIndex;
			this.getAllDocs();
		},
		async handleFileChange(event, index, index1, defineDocuments) {
			this.someAction = true;
			this.deletedIndex = this.docIndex;
			this.defineDocReferenceID = defineDocuments.referenceID;
			this.selectedFileName = defineDocuments.documentName;

			const file = event.target.files[0];
			if (file && file.size > 10 * 1024 * 1024) {
				this.$set(defineDocuments, "maxSize", true);
				this.errorModal("Error", "File size exceeds 10 MB");
				return;
			}

			const isNotPDF = file.type !== "application/pdf";
			this.$set(defineDocuments, "isNotPDF", isNotPDF);

			if (isNotPDF) {
				this.errorModal("Error", "Please upload PDF file ");
				return;
			}
			this.$set(defineDocuments, "maxSize", false);
			this.$set(defineDocuments, "loaderStatus", true);

			this.documents[index].openModal = true;
			this.$forceUpdate();
			this.selectedFile = file;
			this.selectedCategoryIndex = index;
			await this.uploadDocs();
		},
	},
};
</script>

<style scoped>
.candDocs-main-container {
	position: relative;
	background: var(--bg-lightblueback);
	height: calc(100vh - 60px);
	top: 60px;
	/* padding-left: 80px; */
	overflow-x: hidden;
	overflow-y: hidden;
	/* padding-right: 15px; */
	padding: 15px 15px 15px 75px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.candDocs-left-container {
	width: 49.5%;
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	height: calc(100vh - 141px);
}

.candDocs-right-container {
	width: 50%;
	border-radius: 5px;
	background: #fff;
	box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.17);
	height: calc(100vh - 141px);
	/* padding: 20px; */
}

.candDocs-containers {
	height: calc(100vh - 219px);
	overflow-x: hidden;
	overflow-y: auto;
}

.candDocs-sub-containers {
	border-radius: 8px;
	background: #fff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
}

.edu-docs-font {
	color: var(--cv-black);
	font-size: var(--size-16);
	font-weight: var(--weight-LM);
}

.candDocs-particular-doc {
	background: #fff;
	border: 1px solid rgba(140, 140, 140, 0.33);
	border-radius: 8px;
	padding: 4px;
	width: 110px;
	height: 100px;
}

.candDocs-particular-doc-unselected {
	display: flex;
	width: 94px;
	height: 79px;
	background: #fff;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	border: 1px solid #20639b;
	justify-content: center;
	align-items: center;
}

.candDocs-particular-doc-selected {
	background: #fff;
	border: 1px solid #20639b;
	border-radius: 8px;
	padding: 4px;
	width: 94px;
	height: 79px;
}

.candDocs-particular-sub-doc {
	background: #e0edf7;
	border-radius: 8px;
	height: 100%;
	padding: 15px;
}

.candDocs-particular-doc-font {
	font-family: "Lato";
	font-weight: 600;
	font-size: 12px;
	text-align: center;
	color: #3a3c40;
}

.candDocs-particular-others-doc {
	justify-content: center;
	text-align: center;
	height: 79px;
	border: 2px dashed #20639b;
	/* padding: 10px; */
	/* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%2320639BFF' stroke-width='3' stroke-dasharray='8%2c 7' stroke-dashoffset='33' stroke-linecap='butt'/%3e%3c/svg%3e"); */
	/* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%2320639bFF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='18' stroke-linecap='square'/%3e%3c/svg%3e"); */
	/* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%2320639BFF' stroke-width='4' stroke-dasharray='7%2c 13%2c 8%2c 18' stroke-dashoffset='13' stroke-linecap='round'/%3e%3c/svg%3e"); */
	border-radius: 10px;
	/* border: 1px dashed #20639b; */
	/* background: #ffffff; */
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	width: 94px;
	display: flex;
	align-items: center;
}
.candDocs-particular-others-doc-error {
	justify-content: center;
	text-align: center;
	height: 79px;
	border: 2px dashed #eb0002;
	/* padding: 10px; */
	/* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%2320639BFF' stroke-width='3' stroke-dasharray='8%2c 7' stroke-dashoffset='33' stroke-linecap='butt'/%3e%3c/svg%3e"); */
	/* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%2320639bFF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='18' stroke-linecap='square'/%3e%3c/svg%3e"); */
	/* background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='%2320639BFF' stroke-width='4' stroke-dasharray='7%2c 13%2c 8%2c 18' stroke-dashoffset='13' stroke-linecap='round'/%3e%3c/svg%3e"); */
	border-radius: 10px;
	/* border: 1px dashed #20639b; */
	/* background: #ffffff; */
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	border-radius: 8px;
	width: 94px;
	display: flex;
	align-items: center;
}
.red-border-failed {
	background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23EB0002FF' stroke-width='3' stroke-dasharray='8%2c 7' stroke-dashoffset='33' stroke-linecap='butt'/%3e%3c/svg%3e");
}
.preview-docs-font {
	color: var(--cv-gray);
	font-size: var(--size-16);
	font-weight: var(--weight-R);
}

.candDocs-uploadedFile {
	border-radius: 12px;
	border: 1px solid var(--gray-200, #e4e7ec);
	background: var(--base-white, #fff);
	padding: 10px 24px;
	width: 523px;
}

.uploadedFile-font {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
}

.cand-Doc-font {
	color: var(--cv-black);
	font-size: var(--size-18);
	font-weight: var(--weight-M);
}

.pagination-docs-resumePreview-height {
	height: calc(100vh - 291px);
	overflow: auto;
}
.docs-resumePreview-height {
	height: calc(100vh - 220px);
	overflow: auto;
}

.canDocs-uld {
	background: #f6f9fb;
	border-radius: 8px;
	height: 52px;
	width: 100%;
	max-width: 1825px;
}

.canDocs-pg-head {
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 20px;
	color: #20639b;
}

.container-head-uld {
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 16px;
	color: #000000;
	border-bottom: 1px solid #d9d9d9;
}

.card-head-uld {
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 14px;
	color: #000000;
}

.cloud-box-uld {
	width: 81px;
	height: 67px;
	background: #20639b24;
	border-radius: 4px;
	border: 1px solid transparent;
}

.cloud-uld-img {
	height: 34px;
	width: 34px;
}

.uld-file-title {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 12px;
	text-align: center;
	color: #3a3c40;
}

.padding-close {
	padding: 10px 18px 0px 13px;
}
.padding-open {
	padding: 10px 18px 16px 13px;
}
.menu-uld {
	background: #ffffff;
	border: 1px solid rgba(41, 136, 230, 0.22);
	border-radius: 4px;
	width: 130px;
	height: 130px;
	padding: 5px 1px;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
	position: absolute;
	top: 40px;
	right: -110px;
	z-index: 2;
}
.menu-dots-uld {
	position: absolute;
	top: 2px;
	right: 10px;
}
.menu-fonts {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 13px;
	color: #3a3c40;
}
.right-cont-head {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 16px;
	color: #344054;
}
.head-box-uld-left {
	border-bottom: 1px solid #d9d9d9;
}
.w-94px {
	width: 94px;
}
.selected-border {
	border: 2px solid #20639b;
}
.unselected-border {
	border: 0.5px solid #20639b;
}
.blue-txt-selctd {
	color: #20639b;
}
</style>
<style>
.h-95 {
	height: 95px;
}
.bluett {
	display: none;
	z-index: 2;
	padding: 5px;
	position: absolute;
	top: 80px;
	left: -22px;
	width: 160px;
	background: #d9d9d9;
	border-radius: 8.00411px;
}
.bluett-text-primary {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 10px;
	color: #696969;
}
.udarw {
	position: absolute;
	top: -20px;
	left: 38%;
}
.bluett-text-danger {
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 10px;
	color: #eb0002;
}
.docstooltips:hover .bluett {
	display: block;
}

.candDocs-particular-others-doc .custom-file {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
}

.candDocs-particular-others-doc .custom-file-input {
	height: 100%;
}

.candDocs-particular-others-doc .custom-file-label {
	height: 100%;
	width: 100%;
	cursor: pointer;
	opacity: 0;
}
.cloud-card-error {
	font-family: "Lato";
	font-weight: 500;
	font-size: 12px;
	color: #eb0002;
}

.bs-popover-bottom > .arrow::after,
.bs-popover-auto[x-placement^="bottom"] > .arrow::after {
	top: 1px;
	border-width: 0 0.5rem 0.5rem 0.5rem;
	border-bottom-color: #d9d9d9;
}

.popover-body {
	color: #696969;
	background-color: #d9d9d9;
	box-shadow: 0px 4px 4px 0px #00000014;
	border-radius: 8px;
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 10px;
	/* or 30% */
	text-align: center;

	color: #696969;
}

.popover.b-popover {
	border-radius: 9px;
}
.bs-popover-top > .arrow::after,
.bs-popover-auto[x-placement^="top"] > .arrow::after {
	bottom: 1px;
	border-width: 0.5rem 0.5rem 0;
	border-top-color: #d9d9d9;
}
/* .bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
  border-width: 0.4rem 0.4rem 0.4rem 0.4rem;
  border-top-color: #d9d9d9;
} */
.blue-tt .bs-tooltip-top .arrow::before,
.bs-tooltip-auto[x-placement^="top"] .arrow::before {
	top: 0;
	border-width: 0.4rem 0.4rem 0;
	border-top-color: #000;
}
.blue-tt .arrow::after {
	border-width: 0.4rem 0.4rem 0.4rem 0.4rem !important;
	border-left-color: #d9d9d9 !important;
	border-right-color: transparent !important;
	background-color: #d9d9d9;
}
.blue-tt .tooltip-inner {
	color: #696969;
	background-color: #d9d9d9;
	box-shadow: 0px 4px 4px 0px #00000014;
	border-radius: 8px;
	font-family: "Montserrat", sans-serif;
	font-weight: 400;
	font-size: 10px;
	/* or 30% */
	text-align: center;

	color: #696969;
}
#redtooltip .arrow::before {
	border-width: 0.4rem 0.4rem 0.4rem 0.4rem !important;
	border-left-color: #d9d9d9 !important;
	border-right-color: transparent !important;
}
#redtooltip .tooltip-inner {
	text-align: left !important;
	padding: 10px;
	color: #eb0002;
}
.custom-overlay .spinner-border {
	display: inline-block;
	width: 2rem;
	height: 2rem;
	vertical-align: -0.125em;
	border: 0.25em solid currentcolor;
	border-right-color: transparent;
	border-left-color: rgb(126, 122, 122);
	border-top-color: rgb(126, 122, 122);
	border-bottom-color: rgb(126, 122, 122);
	border-radius: 50%;
	-webkit-animation: 0.75s linear infinite spinner-border;
	animation: 0.75s linear infinite spinner-border;
}
.doc-img-bckg {
	background: #f2f6f9;
	border-radius: 28px;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 34px;
	height: 34px;
}
.shimmer-box {
	top: 17px;
}
.head-text {
	padding: 12px;
}
</style>
